import React from "react";
import { useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";

export default function Protected({ children, requireOwner = false }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-lg font-bold tracking-wide">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireOwner && user.role !== "owner") return <Navigate to="/dashboard" replace />;
  return children;
}
